import Link from '@mui/material/Link';
import { Tooltip, Typography } from '@mui/material';

import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

type Props = {
  value: string;
  row: any;
  contactDetailHref?: (id: string) => string;
};

// ----------------------------------------------------------------------

export function RowCellClid({ value, row, contactDetailHref }: Props) {
  const isContact = 'callerType' in row && row.callerType === 'CONTACT';
  const contactId = 'contact' in row && row.contact?.id ? row.contact.id : null;

  if (isContact && contactId && contactDetailHref) {
    return (
      <Link
        component={RouterLink}
        href={contactDetailHref(contactId)}
        color="inherit"
        sx={{
          cursor: 'pointer',
          background: 'none',
          border: 'none',
          padding: 0,
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            color: 'primary.main',
            transform: 'translateX(4px)',
          },
        }}
      >
        {value}
      </Link>
    );
  }

  return (
    <Tooltip title={value || ''}>
      <Typography variant="body2">{value}</Typography>
    </Tooltip>
  );
}
